import { Component, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../../../../shared/services/api.service';
import { CommonService } from '../../../../../shared/services/common.service';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, catchError, debounceTime, distinctUntilChanged, filter, map, merge, of, Subject, Subscription, switchMap, takeUntil } from 'rxjs';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { IAEventDocumentDetails } from '../../../../../shared/models/IAEventDocumentDetails';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { IAEventAttendanceDetails } from '../../../../../shared/models/IAEventAttendanceDetails';
import { ChangeDetectorRef } from '@angular/core';


@Component({
  selector: 'app-iaeventmarkattendance',
  templateUrl: './iaeventmarkattendance.component.html',
  styleUrl: './iaeventmarkattendance.component.css'
})


export class IaeventmarkattendanceComponent implements OnInit {
  private loadEventAttendanceSubscription: Subscription | null = null;
  private loadDataSubscription: Subscription = new Subscription();
  private destroy$: Subject<void> = new Subject<void>();

  eventMarkAttendanceForm: FormGroup;
  eventId: any;
  uploadError: string | null = null;
  fileErrors: { typeError: boolean; sizeError: boolean } = { typeError: false, sizeError: false };
  removedocumentuploadError: string | null = null;
  uploadAttError: string | null = null;
  result: any[] = [];
  data: any = {};
  //reportData: any[] = [];
  UniqueEventId: string = '';
  uniqueEventId: any;

  selectedParticipants: IAEventAttendanceDetails[] = [];
  existingParticipants: string[] = [];

  allSelectedParticipants: string[] = [];

  showNoParticipantsMessage: boolean = false;

  selectedItems: any[] = []; // To store selected items
  document: { name: string, file: File | null }[] = [];
  attendanc: { name: string, file: File | null }[] = [];
  isSubmitted = false;
  AttendanceDetailsData: any[] = [];
  DocumentDetailsData: any[] = [];
  msMeUserName = sessionStorage.getItem('userId');
  length: number = 0;
  pageSize: number = 20;
  displayedData: any[] = [];
  reportData: any[] = [];
  declarationAccepted: boolean = false;
  pageSizeOptions: number[] = [10, 20, 50, 100];
  hidePageSize = false;
  showPageSizeOptions = true;
  showFirstLastButtons = true;
  disabled = false;
  pageIndex = 0;
  pageEvent!: PageEvent;
  DtoPagination =
    {
      "UniqueEventId": '',

      "PageNumber": 1,
      "PageSize": 20,
      "SortColumn": "",
      "SortDirection": "",
      "SearchTerm": "",
      "SearchCol": ""
    }
  dataSource!: MatTableDataSource<IAEventDocumentDetails>
  //displayedColumns: string[] = ['Sr.No', 'IAUserName', 'Intervention', 'Interest', 'CreatedDate', 'DocumentName', 'Download']
  displayedColumns: string[] = ['SrNo', 'DocumentType', 'CreatedDate', 'DocumentName', 'Download', 'Remove'];

  dataSourceattendance!: MatTableDataSource<IAEventAttendanceDetails>
  displayedAttendanceColumns: string[] = ['SrNo', 'UdyamRegistrationNumber','EnterpriseName','ParticipantName','MobileNumber','EnrollmentId', 'CreatedDate'];

  @ViewChild(MatPaginator) pagination!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  term$ = new BehaviorSubject<string>('');
  codeSearch$ = new BehaviorSubject<any>(null);
  nameSearch$ = new BehaviorSubject<any>(null);
  searchText: string = '';
  codeSearchKey: string = '';
  nameSearchKey: string = '';
  isAttendanceSubmitted: boolean = false;

  constructor(private apiService: ApiService, private commonService: CommonService, private fb: FormBuilder, private router: Router, private route: ActivatedRoute, private toastrService: ToastrService, private cdRef: ChangeDetectorRef) {

    this.eventMarkAttendanceForm = this.fb.group({
      //name: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(100), Validators.pattern(this.commonService.nameWithSpacePattern)]),
      /*documents: this.fb.array([this.createDocument()]),*/
      //docAttendanceName: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(100), Validators.pattern(this.commonService.nameWithSpacePattern)]),
      /*attendance: this.fb.array([this.createAttendanceDocument()]),*/
      declarationAccepted: this.fb.control(false),
      selectedParticipants: this.fb.array([]) // FormArray to hold selected rows
      // Declare the Declaration form control
      //declarationAccepted: this.fb.control(false, [Validators.requiredTrue]),

    });

  };

  get f() {
    return this.eventMarkAttendanceForm.controls;
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.eventId = params['eventid'];
    });
    this.GetEventParticipants();
    this.DtoPagination.PageSize = 20;
    this.DtoPagination.SearchTerm = this.commonService.searchText;
  };
  ngAfterViewInit() {
    
   // this.loadEventIAAttendanceWithUdyamDetails();
  }

  //previous
  onSubmit(key : string) {
    //this.eventId;

    if (key === 'submit') {
      if (window.confirm("Are you sure you want to submit the attendance? Once it is submitted no further change will be allowed")) {
        this.onSubmitForSubmitButton('submit');
      }
      else {
        // This block is optional but can be used to handle the "Cancel" action.
        // If the user clicks "Cancel," no action is taken, and they remain on the same page.
        console.log("Submission canceled.");
      }
    }
    else {
      //this.isSubmitted = true;
      if (this.eventMarkAttendanceForm.valid) {

        const formData = new FormData();
        let participantIndex = 0; // Use a single, running index for all participants

        const declarationAccepted = this.eventMarkAttendanceForm.get('declarationAccepted')?.value;


        // Extract the documents array from the form (form controls under 'documents' FormArray)
        //const documents = this.documents.controls.map((docControl: any) => ({
        //  name: docControl.get('name')?.value,
        //  file: docControl.get('file')?.value // This will be the file object (PDF)
        //}));
        //this.document = documents;

        //const attandence = this.attendance.controls.map((docControl: any) => ({
        //  name: docControl.get('docAttendanceName')?.value,
        //  file: docControl.get('file')?.value // This will be the file object (PDF)
        //}));
        //this.attendanc = attandence;

        //this.document.forEach((doc: { name: string, file: File | null }, index: number) => {
        //  if (doc.file) {
        //    formData.append(`documents[${index}].name`, doc.name);
        //    formData.append(`documents[${index}].file`, doc.file, doc.file.name);
        //  }
        //});

        //this.attendanc.forEach((doc: { name: string, file: File | null }, index: number) => {
        //  if (doc.file) {
        //    formData.append(`attendances[${index}].name`, doc.name);
        //    formData.append(`attendances[${index}].file`, doc.file, doc.file.name);
        //  }
        //});









        // Extract selectedParticipants
        //const selectedParticipants = this.eventMarkAttendanceForm.get('selectedParticipants')?.value;




        // Append selected participants to formData
        //this.selectedParticipants.forEach((participant: any, index: number) => {
        //  formData.append(`selectedParticipants[${index}].UdyamRegistrationNumber`, participant.UdyamRegistrationNumber);
        //  formData.append(`selectedParticipants[${index}].ParticipantName`, participant.ParticipantName);
        //  formData.append(`selectedParticipants[${index}].NameOfEnterprise`, participant.NameOfEnterprise);
        //  formData.append(`selectedParticipants[${index}].MobileNumber`, participant.MobileNumber);
        //  formData.append(`selectedParticipants[${index}].EnrollmentId`, participant.EnrollmentId);
        //  formData.append(`selectedParticipants[${index}].IsChecked`, participant.IsChecked);

        //});

        //if (this.selectedParticipants.length === 0) {
        //  // If empty, use existingParticipants
        //  this.existingParticipants.forEach((participant: any, index: number) => {
        //    formData.append(`selectedParticipants[${index}].UdyamRegistrationNumber`, participant.UdyamRegistrationNumber);
        //    formData.append(`selectedParticipants[${index}].ParticipantName`, participant.ParticipantName);
        //    formData.append(`selectedParticipants[${index}].NameOfEnterprise`, participant.NameOfEnterprise);
        //    formData.append(`selectedParticipants[${index}].MobileNumber`, participant.MobileNumber);
        //    formData.append(`selectedParticipants[${index}].EnrollmentId`, participant.EnrollmentId);
        //    formData.append(`selectedParticipants[${index}].IsChecked`, participant.IsChecked);
        //  });
        //}


        // Always append existingParticipants first
        this.existingParticipants.forEach((participant: any) => {
          formData.append(`selectedParticipants[${participantIndex}].UdyamRegistrationNumber`, participant.UdyamRegistrationNumber);
          formData.append(`selectedParticipants[${participantIndex}].ParticipantName`, participant.ParticipantName);
          formData.append(`selectedParticipants[${participantIndex}].NameOfEnterprise`, participant.NameOfEnterprise);
          formData.append(`selectedParticipants[${participantIndex}].MobileNumber`, participant.MobileNumber);
          formData.append(`selectedParticipants[${participantIndex}].EnrollmentId`, participant.EnrollmentId);
          formData.append(`selectedParticipants[${participantIndex}].IsChecked`, participant.IsChecked);
          participantIndex++;
        });

        // If selectedParticipants is not empty, append them as well
        if (this.selectedParticipants.length > 0) {
          this.selectedParticipants.forEach((participant: any) => {
            formData.append(`selectedParticipants[${participantIndex}].UdyamRegistrationNumber`, participant.UdyamRegistrationNumber);
            formData.append(`selectedParticipants[${participantIndex}].ParticipantName`, participant.ParticipantName);
            formData.append(`selectedParticipants[${participantIndex}].NameOfEnterprise`, participant.NameOfEnterprise);
            formData.append(`selectedParticipants[${participantIndex}].MobileNumber`, participant.MobileNumber);
            formData.append(`selectedParticipants[${participantIndex}].EnrollmentId`, participant.EnrollmentId);
            formData.append(`selectedParticipants[${participantIndex}].IsChecked`, participant.IsChecked);
            participantIndex++;
          });
        }


        formData.append('UniqueEventId', this.eventId);
        //formData.append('IsAttendanceSubmitted', 'false');
        formData.append('key', key);
        // Append the declarationAccepted value to the FormData object
        formData.append('declarationAccepted', declarationAccepted);

        this.apiService.postRequest(API_ENDPOINTS.IA.SAVEIAEVENTATTENDANCE, formData).subscribe(
          (result: any) => {
            this.toastrService.success('Attendance marked successfully!', 'Record Added!');
            this.router.navigate(['/view_event']);
          },
          //error => {
          //  this.toastrService.error(error, 'Information cannot be saved. Please check for errors indicated in red.');
          //  //console.error('Error saving data:', error);
          //}
        );

      } else {

        this.eventMarkAttendanceForm.markAllAsTouched();
        return;
      }
    }
    


  }


  
  //tried
  //onSubmit() {
  //  if (this.eventMarkAttendanceForm.valid) {
  //    const formData = new FormData();

  //    // Get existing selected participants
  //    const existingParticipants = this.existingParticipants || [];

  //    // Get newly selected participants from the form
  //    const newParticipants = this.eventMarkAttendanceForm.get('selectedParticipants')?.value || [];

  //    // Merge existing and new participants, ensuring no duplicates
  //    this.allSelectedParticipants = [...new Set([...existingParticipants, ...newParticipants])];

  //    // Append merged participants to formData
  //    this.allSelectedParticipants.forEach((participant: any, index: number) => {
  //      formData.append(`selectedParticipants[${index}].UdyamRegistrationNumber`, participant.UdyamRegistrationNumber);
  //      formData.append(`selectedParticipants[${index}].ParticipantName`, participant.ParticipantName);
  //      formData.append(`selectedParticipants[${index}].NameOfEnterprise`, participant.NameOfEnterprise);
  //      formData.append(`selectedParticipants[${index}].MobileNumber`, participant.MobileNumber);
  //      formData.append(`selectedParticipants[${index}].EnrollmentId`, participant.EnrollmentId);
  //      formData.append(`selectedParticipants[${index}].IsChecked`, participant.IsChecked);
  //    });

  //    // Append event ID
  //    formData.append('UniqueEventId', this.eventId);

  //    // Submit form data to the API
  //    this.apiService.postRequest(API_ENDPOINTS.IA.SAVEIAEVENTATTENDANCE, formData).subscribe(
  //      (result: any) => {
  //        if (result.status) {
  //          this.toastrService.success('Implementation Details added successfully!', 'Good job!');
  //          this.router.navigate(['/view_event']);
  //        }
  //      },
  //      error => {
  //        let errorMessage = "An error occurred during submission.";
  //        if (error.status === 409) {
  //          errorMessage = "Duplicate participant detected.";
  //        } else if (error.status === 400) {
  //          errorMessage = "Invalid request data.";
  //        }
  //        alert(errorMessage);
  //      }
  //    );
  //  } else {
  //    this.eventMarkAttendanceForm.markAllAsTouched();
  //  }
  //}


  GetEventParticipants() {
    this.apiService.getRequest(API_ENDPOINTS.IA.GETEVENTSPARTICIPANTSDETAILS, { UniqueEventId: this.eventId }).subscribe(
      result => {
        // Get a reference to the control once
        const declarationControl = this.eventMarkAttendanceForm.get('declarationAccepted');
        if (result.status) {
          if (result.message == 'No Participants') {
            this.showNoParticipantsMessage = true;

            if (declarationControl) {
              declarationControl.setValidators(Validators.requiredTrue);
              declarationControl.updateValueAndValidity(); // Apply validation immediately
            }
          }
          else {
            this.reportData = result.data;
            // Filter participants where IsChecked is true
            this.existingParticipants = this.reportData.filter((participant: any) => participant.IsChecked === true);
            //this.existingParticipants = this.reportData; }

            // Crucial: Remove the validator if data IS present
            if (declarationControl) {
              declarationControl.setValidators(null);
              declarationControl.updateValueAndValidity(); // Apply change
            }

          }



        }
      }

    );
    
    

  }

  onCheckboxChange(event: any, item: any) {

    const inputElement = event.target as HTMLInputElement;
    const isChecked = inputElement.checked;
    item.IsChecked = isChecked; // Update the IsChecked property in the reportData

    // Update the selectedParticipants array
    const existingIndex = this.selectedParticipants.findIndex(
      p => p.EnrollmentId === item.EnrollmentId
    );

    if (existingIndex > -1) {
      // If the item exists, update its IsChecked status
      this.selectedParticipants[existingIndex] = { ...item };
    } else {
      // If the item doesn't exist, add it
      this.selectedParticipants.push({ ...item });
    }

    console.log(this.selectedParticipants);
    // Find the corresponding item in the previousReportData
    //const previousItem = this.reportData.find(
    //  previtem => previtem.EnrollmentId === item.EnrollmentId
    //);

    //if (previousItem && previousItem.IsChecked !== item.IsChecked) {
    //  // If the IsChecked status has changed, update selectedParticipants
    //  if (item.IsChecked) {
    //    // Checkbox was checked
        //if (!this.selectedParticipants.some(p => p.enrollmentId === item.EnrollmentId)) {
        //  this.selectedParticipants.push({ ...item }); // Push a copy
       // }
      //} else {
      //  // Checkbox was unchecked
      //  this.selectedParticipants = this.selectedParticipants.filter(
      //    p => p.enrollmentId !== item.EnrollmentId
      //  );
      //}


    //}


    //if (this.existingParticipants) {//update
    //  const inputElement = event.target as HTMLInputElement;
    //  const isChecked = inputElement.checked;
    //  this.selectedParticipants = this.existingParticipants;
    //  if (isChecked) {
    //    //if (!this.selectedParticipants.includes(enrollmentId)) {
    //    //  this.selectedParticipants.push(enrollmentId);
    //    //  this.selectedParticipants.push(udyamRegistrationNumber);
    //    //  this.selectedParticipants.push(participantName);
    //    //  this.selectedParticipants.push(nameOfEnterprise);
    //    //  this.selectedParticipants.push(mobileNumber);
    //    //}
    //    //if (!this.selectedParticipants.some(participant => participant.enrollmentId === enrollmentId)) {
    //    //  // Create an object and push it into the array
    //    //  const participantObject = {
    //    //    enrollmentId,
    //    //    udyamRegistrationNumber,
    //    //    participantName,
    //    //    nameOfEnterprise,
    //    //    mobileNumber
    //    //  };
    //    //  this.selectedParticipants.push(participantObject);
    //    //}
    //    else {
    //      const index = this.selectedParticipants.indexOf(enrollmentId);
    //      if (index > -1) {
    //        this.selectedParticipants.splice(index, 1);
    //      }
    //    }

    //  }
    //} else {
    //  //insert
    //  const inputElement = event.target as HTMLInputElement;
    //  const isChecked = inputElement.checked;
    //  const selectedParticipants = this.eventMarkAttendanceForm.get('selectedParticipants') as FormArray;
    //  //const selectedParticipants = this.existingParticipants;
    //  if (isChecked) {
    //    // Add the selected row to the FormArray
    //    selectedParticipants.push(
    //      this.fb.group({
    //        UdyamRegistrationNumber: udyamRegistrationNumber,
    //        ParticipantName: participantName,
    //        NameOfEnterprise: nameOfEnterprise,
    //        MobileNumber: mobileNumber,
    //        EnrollmentId: enrollmentId,
    //        isChecked: event.target.checked
    //      })
    //    );
    //  } else {
    //    // Remove the unselected row from the FormArray
    //    const index = selectedParticipants.controls.findIndex(
    //      (group: any) =>
    //        group.value.UdyamRegistrationNumber === udyamRegistrationNumber
    //    );
    //    if (index !== -1) {
    //      selectedParticipants.removeAt(index);
    //    }
    //    else {
    //      const index = this.selectedParticipants.indexOf(enrollmentId);
    //      if (index > -1) {
    //        this.selectedParticipants.splice(index, 1);
    //      }
    //    }
    //  }

    //}
  }
  


  //onCheckboxChange(event: Event, udyamRegistrationNumber: string, participantName: string, nameOfEnterprise: string, mobileNumber: string, enrollmentId: string) {
  //  const inputElement = event.target as HTMLInputElement;
  //  const isChecked = inputElement.checked;
  //  this.selectedParticipants = this.existingParticipants || [];

  //  if (isChecked) {
  //    if (!this.selectedParticipants.includes(enrollmentId)) {
        
  //        this.selectedParticipants.push(udyamRegistrationNumber);
  //      this.selectedParticipants.push(participantName);
  //      this.selectedParticipants.push(nameOfEnterprise);
  //      this.selectedParticipants.push(mobileNumber);
  //      this.selectedParticipants.push(enrollmentId);
          
        
  //    }
  //  } else {
  //    const index = this.selectedParticipants.indexOf(enrollmentId);
  //    if (index > -1) {
  //      this.selectedParticipants.splice(index, 1);
  //    }
  //  }
  //}


  //llloadEventIAAttendanceWithUdyamDetails() {
  //  this.DtoPagination.UniqueEventId = this.eventId;
  //  if (!this.pagination) return;
  //  // Unsubscribe from previous subscription to prevent multiple API calls
  //  if (this.loadEventAttendanceSubscription) {
  //    this.loadEventAttendanceSubscription.unsubscribe();
  //  }

  //  this.loadEventAttendanceSubscription = merge(
  //    this.sort.sortChange.pipe(takeUntil(this.destroy$)),
  //    this.term$.pipe(debounceTime(1100), distinctUntilChanged(), takeUntil(this.destroy$)),
  //    this.pagination.page.pipe(takeUntil(this.destroy$))
  //  )
  //    .pipe(
  //      filter(searchTerm => searchTerm != null),
  //      switchMap(() => {
  //        this.pagination.pageIndex = 0;
  //        this.DtoPagination.SortColumn = this.sort.active;
  //        this.DtoPagination.SortDirection = this.sort.direction;
  //        this.DtoPagination.SearchCol = this.commonService.searchText;

  //        return this.apiService
  //          .getRequest(API_ENDPOINTS.IA.GETEVENTIAATTENDANCEWITHUDYAM, this.DtoPagination)
  //          .pipe(catchError(() => of(null)));
  //      }),
  //      map(resp => {
  //        if (resp && resp.status) {
  //          this.length = resp['totalRecords'];
  //        }
  //        return resp?.data || {};
  //      })
  //    )
  //    .subscribe(data => {
  //      this.AttendanceDetailsData = data;
  //      this.adjustPaginator();
  //    });
  //}

  loadEventIAAttendanceWithUdyamDetails() {
    this.DtoPagination.UniqueEventId = this.eventId;

    // Unsubscribe from previous subscription to prevent multiple API calls
    if (this.loadEventAttendanceSubscription) {
      this.loadEventAttendanceSubscription.unsubscribe();
    }

    this.loadEventAttendanceSubscription = this.apiService
      .getRequest(API_ENDPOINTS.IA.GETEVENTIAATTENDANCEWITHUDYAM, this.DtoPagination)
      .pipe(
        catchError(() => of(null)), // Handle errors gracefully
        map(resp => {
          return resp?.data || {}; // Extract data from response
        })
      )
      //.subscribe(data => {
      //  this.AttendanceDetailsData = data;
      //});
      .subscribe((data: any[]) => {
        this.AttendanceDetailsData = data.map((item: any) => ({
          ...item,
          isChecked: !!item.isChecked // Ensure null or undefined values convert to false
        }));
      });
  }

  //loadEventIAAttendanceWithUdyamDetails() {
  //  this.DtoPagination.UniqueEventId = this.eventId;

  //  // Unsubscribe from previous subscription to prevent multiple API calls
  //  if (this.loadEventAttendanceSubscription) {
  //    this.loadEventAttendanceSubscription.unsubscribe();
  //  }

  //  this.loadEventAttendanceSubscription = this.apiService
  //    .getRequest(API_ENDPOINTS.IA.GETEVENTIAATTENDANCEWITHUDYAM, this.DtoPagination)
  //    .pipe(
  //      catchError(() => of(null)), // Handle errors gracefully
  //      map(resp => resp?.data || []) // Extract saved records or return an empty array
  //    )
  //    .subscribe((savedData: any[]) => {
  //      this.AttendanceDetailsData = this.AttendanceDetailsData.map((item: any) => ({
  //        ...item,
  //        isChecked: savedData.some((saved: any) => saved.udyamRegistrationNumber === item.udyamRegistrationNumber)
  //      }));
  //    });
  //}



  adjustPaginator() {
    const totalPages = Math.ceil(this.length / this.pageSize);

    // If the current page index is greater than or equal to total pages, move to the last page
    if (this.pageIndex >= totalPages) {
      this.pageIndex = totalPages - 1; // Set to the last valid page
      this.DtoPagination.PageNumber = this.pageIndex + 1; // Update for 1-based pagination
    }

    // Update the paginator with the adjusted page index
    this.pagination.pageIndex = this.pageIndex;
  }
  onSubmitForSubmitButton(key: string) {
    //this.isSubmitted = true;
    if (this.eventMarkAttendanceForm.valid) {

      const formData = new FormData();
      let participantIndex = 0; // Use a single, running index for all participants

      const declarationAccepted = this.eventMarkAttendanceForm.get('declarationAccepted')?.value;
      
      this.existingParticipants.forEach((participant: any) => {
        formData.append(`selectedParticipants[${participantIndex}].UdyamRegistrationNumber`, participant.UdyamRegistrationNumber);
        formData.append(`selectedParticipants[${participantIndex}].ParticipantName`, participant.ParticipantName);
        formData.append(`selectedParticipants[${participantIndex}].NameOfEnterprise`, participant.NameOfEnterprise);
        formData.append(`selectedParticipants[${participantIndex}].MobileNumber`, participant.MobileNumber);
        formData.append(`selectedParticipants[${participantIndex}].EnrollmentId`, participant.EnrollmentId);
        formData.append(`selectedParticipants[${participantIndex}].IsChecked`, participant.IsChecked);
        participantIndex++;
      });

      // If selectedParticipants is not empty, append them as well
      if (this.selectedParticipants.length > 0) {
        this.selectedParticipants.forEach((participant: any) => {
          formData.append(`selectedParticipants[${participantIndex}].UdyamRegistrationNumber`, participant.UdyamRegistrationNumber);
          formData.append(`selectedParticipants[${participantIndex}].ParticipantName`, participant.ParticipantName);
          formData.append(`selectedParticipants[${participantIndex}].NameOfEnterprise`, participant.NameOfEnterprise);
          formData.append(`selectedParticipants[${participantIndex}].MobileNumber`, participant.MobileNumber);
          formData.append(`selectedParticipants[${participantIndex}].EnrollmentId`, participant.EnrollmentId);
          formData.append(`selectedParticipants[${participantIndex}].IsChecked`, participant.IsChecked);
          participantIndex++;
        });
      }


      formData.append('UniqueEventId', this.eventId);
      //formData.append('IsAttendanceSubmitted', 'false');
      formData.append('key', key);
      // Append the declarationAccepted value to the FormData object
      formData.append('declarationAccepted', declarationAccepted);
      


      this.apiService.postRequest(API_ENDPOINTS.IA.SAVEIAEVENTATTENDANCE, formData).subscribe(
        (result: any) => {
          this.toastrService.success('Attendance marked successfully!', 'Good job!');
          this.router.navigate(['/view_event']);
        },
        //error => {
        //  this.toastrService.error(error, 'Information cannot be saved. Please check for errors indicated in red.');
        //  //console.error('Error saving data:', error);
        //}
      );

    } else {

      this.eventMarkAttendanceForm.markAllAsTouched();

      // Check if the declaration control is currently invalid AND we are showing the no-participants message
      const declarationControl = this.eventMarkAttendanceForm.get('declarationAccepted');

      if (this.showNoParticipantsMessage && declarationControl?.invalid) {
        // Show a specific error message for the declaration
        this.toastrService.error('Please check the declaration checkbox to confirm the event status.', 'Confirmation Required');
      } else {
        // Fallback for other validation errors (e.g., if you add other required fields)
        this.toastrService.error('Please fix all indicated errors before submitting.', 'Validation Failed');
      }
      return;
    }
}
  confirmSubmit() {
    if (window.confirm("Are you sure you want to submit the attendance? Once it is submitted no further change will be allowed")) {
      //this.onSubmitForSubmitButton(); // Call the original onSubmit method
      this.isAttendanceSubmitted = true;
    }
  }
}
